// extracted by mini-css-extract-plugin
export default {"box":"containers_box__RMsm9"};